<script>
	import { link } from "svelte-spa-router";

	import SupportSelector from "./SupportSelector.svelte";
	import Button from "./ui/Button.svelte";
	import { licenses, supports, products, buyLink, buyPrice } from "./data";

	export let product;

	const obj = products[product];

	const list = licenses.map(a => ({ ...a }));
	const pack = list[0];
	pack.price = obj.price + 299;
	pack.code = [].concat(pack.code).concat(obj.code);
	pack.package = obj.name;

	function changeSupport(e) {
		const { value, license } = e.detail;
		const index = list.findIndex(a => a.name === license.name);
		const now = list[index];

		if (value === now.support) return;

		now.support = value;
		now.price = buyPrice(now);
		list = list;
	}
</script>

<div class="block">
	<div class="table js-table">
		<div class="column params">
			<div>License type</div>
			<div>License Terms</div>
			<div>Package</div>
			<div>Projects</div>
			<div>Developers</div>
			<div>Support</div>
			<div>Support tickets</div>
			<div>Response time</div>
			<div />
		</div>

		{#each list as obj}
			<div class="column mobile">
				<div>License type</div>
				<div>License Terms</div>
				<div>Package</div>
				<div>Projects</div>
				<div>Developers</div>
				<div>Support</div>
				<div>Support tickets</div>
				<div>Response time</div>
				<div />
			</div>
			<div class="column">
				<div class="header">{obj.name}</div>
				<div class="white">
					<a href={obj.link} target="_blank">Read License Agreements</a>
				</div>
				<div class="ultralight">
					<span>{obj.package}</span>
				</div>
				<div class="white">
					{obj.projects === Infinity ? 'Unlimited projects' : obj.projects}
				</div>
				<div class="ultralight">
					{(obj.devs === Infinity ? 'Unlimited' : obj.devs) + ' developer' + (obj.devs > 1 ? 's' : '')}
				</div>
				<div class="white">
					<SupportSelector
						support={supports[obj.support]}
						license={obj}
						on:change={changeSupport} />
				</div>
				<div class="ultralight">{supports[obj.support].tickets}</div>
				<div class="white">Up to {supports[obj.support].hours} hours</div>
				<div class="buy ultralight">
					<div class=" price">
						<span>
							{#if obj.price < 2000}
								<span style="font-weight:400;">from</span>
							{/if}
							$
							<span class="js-price-cost">{obj.price}</span>
							<span />
						</span>
					</div>
					{#if obj.id !== 'custom'}
						<a href={'/preview-pack/' + obj.id} use:link>Customize</a>
						<Button href={buyLink(obj)} label="Buy Now" />
					{:else}
						<a
							class="topPadding"
							href={'/preview-pack/custom/' + product}
							use:link>
							<Button label="Customize" />
						</a>
					{/if}
				</div>
			</div>
		{/each}
	</div>
</div>

<style>
	.block {
		color: rgba(0, 0, 0, 0.6);
		margin-top: 2rem;

		font-family: Roboto;
		font-style: normal;
		font-size: 16px;
		line-height: 25px;

		box-sizing: border-box;
		font-kerning: auto;
		-webkit-font-smoothing: antialiased;
		vertical-align: baseline;
	}
	.table {
		background-color: #dedede;
		display: grid;
		grid-template-columns: auto repeat(4, 1fr);
		grid-column-gap: 1px;
		box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);
		width: 100%;
		overflow-x: auto;
	}
	.column {
		display: grid;
		grid-template-rows: repeat(8, 1fr) 199px;
		grid-row-gap: 1px;
		overflow: hidden;
	}
	.params,
	.mobile {
		max-width: 15rem;
		font-weight: 500;
	}
	.column > div {
		background-color: #f7f7fa;
		padding: 0 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		position: relative;
		min-height: 60px;
	}
	.column .header {
		background-color: #7e57c2;
		color: #fff;
		font-size: 18px;
		line-height: 30px;
		text-transform: uppercase;
	}
	.column .white {
		background-color: #fff;
	}
	.column .ultralight {
		background-color: #fbfbfd;
	}
	.price {
		font-weight: 500;
		font-size: 24px;
		line-height: 35px;
		color: #7e57c2;
		margin-bottom: 1rem;
	}
	.mobile {
		display: none;
	}
	.topPadding {
		padding-top: 26px;
	}
	@media screen and (max-width: 890px) {
		.params {
			display: none;
		}
		.table {
			grid-template-columns: auto repeat(1, 1fr);
		}
		.mobile {
			display: grid;
		}
		.column {
			margin-bottom: 1px;
		}
		.column .header {
			font-size: 16px;
			line-height: 24px;
		}
		.block {
			font-size: 14px;
			line-height: 21px;
		}
	}
	@media screen and (max-width: 460px) {
		.mobile {
			font-size: 12px;
			max-width: 80px;
		}
		.column > div {
			padding: 0 8px;
		}
	}
</style>
